@if (loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div *ngIf="priceRate" class="container-fluid p-3 mb-5">
        <div class="w-fit">
            <app-back-button url="/price-rates" component="Price Rates"></app-back-button>
        </div>
        <div class="mt-3 mb-2 d-flex justify-content-between">
            <h1>{{ priceRate.name }}</h1>
            <div class="d-flex mt-2 me-1">
                <button mat-raised-button class="action-button d-flex col-auto align-items-center" (click)="onEditPriceRateClick()">
                    <mat-icon class="button-icon">add</mat-icon>
                    Edit Price Rate
                </button>
                <button mat-raised-button class="warn-button d-flex col-auto align-items-center" style="margin-left:8px;" (click)="onDeletePriceRateClick()">
                    <mat-icon class="button-icon">delete</mat-icon>
                    Delete Price Rate
                </button>
            </div>
        </div>
        <div class="p-2">
            <app-detail-info-card [data]="priceRateDetails"></app-detail-info-card>
        </div>
        <div class="p-2" *ngIf="priceRate.night_ranges.length > 0">
            <mat-card appearance="outlined" class="p-3">
                <div class="d-flex align-items-center my-3">
                    <div class="col-lg-9 col-12">
                        <h4>Tiered Night Pricing</h4>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12">
                        <table mat-table *ngIf="dataSource" class="nightly-range-table" [dataSource]="dataSource">
                            <ng-container [matColumnDef]="column.column" *ngFor="let column of displayedColumns">
                                <th mat-header-cell *matHeaderCellDef>{{ column.display }}</th>
                                <td mat-cell *matCellDef="let element">{{ element[column.column] }}</td>    
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnNames"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnNames;"></tr>
                        </table>          
                    </div>
                </div>
                <div class="row p-3">
                    <div class="col">
                        <div class="extra-night">Extra Night Price: {{extraNightPrice}}</div>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
}